type GraphURL = string;
type OrgID = string;
type AccountID = string;
type UserID = string;
type DataRow = { user: UserID };

export function GetGraphDashboardOrganization(
  graphURL: GraphURL,
  orgID: OrgID,
): string {
  return `${graphURL}/to/resource_url_organization/${orgID}`;
}

export function GetGraphDashboardAccount(
  graphURL: GraphURL,
  accountID: AccountID,
): string {
  return `${graphURL}/to/resource_url_account/${accountID}`;
}

export function GetGraphDashboardUser(
  graphURL: GraphURL,
  userID: UserID,
): string {
  return `${graphURL}/to/resource_url_user/${userID}`;
}

export function GetGraphDashboardStorage(
  graphURL: GraphURL,
  orgID: OrgID,
): string {
  return `${graphURL}/to/resource_url_storage/${orgID}`;
}

export function GetGraphDashboardAccountRow(
  graphURL: GraphURL,
  dataRow: DataRow,
): string {
  // TODO: this seems not correct because GetGraphDashboardAccount takes in an account ID, not a user ID
  // But it seems like maybe this parameter isn't actually used in practice?
  return GetGraphDashboardAccount(graphURL, dataRow.user);
}
